import React from 'react'

export default React.createContext({
   lang: 'fr',
   setLang: (value: any) => value,
})
